import React from "react";
import { DataProvider, getJwtData } from "../../providers";
import { GET_LIST, CREATE } from "react-admin";
import CommentIcon from "@material-ui/icons/Comment";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import ArchiveIcon from "@material-ui/icons/Archive";
import PersonPinCircle from "@material-ui/icons/PersonPinCircle";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import TodayIcon from "@material-ui/icons/Today";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import StarIcon from "@material-ui/icons/Star";
import { DatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import MomentUtils from "@date-io/moment";
//import DynamicListBolsones from "./DynamicListBolsones";
import { styles } from "../../layout/Styles";
import "moment/locale/es";

import moment from "moment";

moment.locale("es");

export class PesajeCreateComponent extends React.Component {
  constructor(props) {
    super(props);
    this.inputButtonRef = React.createRef();
    this.state = {
      user: {},
      open: true,
      etapasList: [],
      prediosList: [],
      materialesList: [],
      isSaving: false,
      cartoneroNombre: " ",
      cartonerosDeUnaEtapa: [],
      pesaje: {
        fecha: moment()
          .utc(new Date())
          .local(),
        pesador: "",
        predio: "",
        material: "",
        cartonero: "",
        etapa: "",
        bolson: [],
        peso: "",
        comentario: "",
        camion: ""
      }
    };
  }

  componentDidMount() {
    const jwt = getJwtData();
    const user = { _id: jwt.usuariosId, _rol: jwt.role, _nombre: jwt.nombre };

    DataProvider(GET_LIST, "usuarios", {
      filter: { _id: jwt.usuariosId }
    }).then(response => {
      response.data[0]._rol === "pesador" &&
        response.data[0].predio &&
        this.handleChange("predio", response.data[0].predio);

      this.setState({
        user: response.data[0]
      });

      DataProvider(GET_LIST, "etapas", { field: "nombre", order: "ASC" }).then(
        resp => {
          const etapasList = resp.data;
          this.setState({
            etapasList,
            pesaje: {
              fecha: this.getFechaDeHoy(),
              pesador: user._id,
              predio: response.data[0].predio,
              cartonero: "",
              etapa: "",
              bolson: "",
              peso: "",
              comentario: "",
              camion: ""
            }
          });
        }
      );

      DataProvider(GET_LIST, "predios", {}).then(resp => {
        const prediosList = resp.data;
        this.setState({
          prediosList
        });
      });
    });
    DataProvider(GET_LIST, "materiales", {filter: {enPesajes:true}}).then(response => {
      const materialesList = response.data;
      this.setState({
        materialesList
      });
    });
  }

  getFechaDeHoy = () => {
    return moment()
      .utc(new Date())
      .local();
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ isSaving: true });

    return DataProvider(CREATE, "pesajes", {
      data: { ...this.state.pesaje, createdAt: new Date() }
    })
      .then(() => {
        this.setState({
          pesaje: {
            pesador: this.state.pesaje.pesador,
            predio: this.state.pesaje.predio,
            fecha: this.state.pesaje.fecha,
            material: this.state.pesaje.material,
            cartonero: "",
            etapa: this.state.pesaje.etapa,
            bolson: "",
            peso: "",
            comentario: "",
            camion: this.state.pesaje.camion
          },
          cartoneroNombre: ""
        });
        this.handleFocus("bolson_1");
        this.setState({ isSaving: false });
      })
      .catch(error => {
        console.log("Error", error);
      });
    //.finally(this.setState({ isSaving: false }));
  };

  handleChange = (name, value) => {
    const newpesaje = this.state.pesaje;
    // if (name === "bolson") newpesaje["bolson"][i] = event.target.value;
    // else newpesaje[name] = event.target.value;
    newpesaje[name] = value;
    this.setState({
      pesaje: newpesaje
    });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.history.push("/pesajes");
  };

  handleKeyDown = e => {
    if (e.key === "Enter") {
      this.handleSubmit(e);
    }
  };

  handleKeyDownBolson = e => {
    if (e.key === "Enter") {
      this.handleFocus("peso");
    }
  };

  handleFocus = id => {
    document.getElementById(id).focus();
  };

  transition = props => {
    return <Slide direction="left" {...props} />;
  };

  handleBolsonInputChange = event => {
    this.setState({ cartoneroNombre: " " });
    this.handleChange("cartonero", "");
    const bolson = event.target.value;
    this.handleChange("bolson", bolson);
    const cartonero = this.state.cartonerosDeUnaEtapa.find(cartonero => {
      return String(cartonero.bolson) === String(bolson);
    });
    if (cartonero) {
      this.handleChange("cartonero", cartonero._id);
      this.setState({ cartoneroNombre: cartonero.nombre });
    }
  };

  renderPesaje = () => {
    return (
      <Grid item xs={12} md={6}>
        <Paper style={styles.paperIcon}>
          <LocalOfferIcon style={styles.iconLeftBig} />
          <FormControl margin="normal" fullWidth>
            <InputLabel htmlFor="bolson">Número de bolsón</InputLabel>
            <Input
              id={`bolson_1`}
              type="number"
              style={styles.inputBig}
              value={this.state.pesaje.bolson}
              onChange={this.handleBolsonInputChange}
              disabled={this.state.pesaje.etapa === ""}
              onKeyDown={this.handleKeyDownBolson}
            />
          </FormControl>
          <Typography variant="title" align="left" style={{marginBottom:'20px'}}>
            {this.state.cartoneroNombre}
          </Typography>
          <FormControl fullWidth>
            <InputLabel htmlFor="predio">Material</InputLabel>
            <Select
              value={this.state.pesaje.material}
              onChange={this.handleMateriales}
              input={<Input name="nombre" id="materiales-helper" />}
            >
              {this.state.materialesList &&
                this.state.materialesList.map((value, i) => (
                  <MenuItem key={`predios_${i}}`} value={value._id}>
                    {value.nombre}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Paper>
      </Grid>
    );
  };

  renderWeightInfo = () => {
    return (
      <Grid item xs={12} md={3}>
        <Paper style={styles.paperIcon}>
          <ArchiveIcon style={styles.iconLeft} />
          <FormControl fullWidth>
            <InputLabel htmlFor="Peso">Peso</InputLabel>
            <Input
              id="peso"
              type="number"
              value={this.state.pesaje.peso}
              disabled={this.state.isSaving}
              onChange={event => {
                this.handleChange("peso", event.target.value);
              }}
              style={styles.inputBig}
              onKeyDown={this.handleKeyDown}
              endAdornment={<InputAdornment position="end">Kg</InputAdornment>}
            />
          </FormControl>
        </Paper>
        <Paper style={styles.paper}>
          <FormControl fullWidth>
            <InputLabel htmlFor="comentario">Comentario</InputLabel>
            <Input
              id="comentario"
              name="comentario"
              value={this.state.pesaje.comentario}
              onKeyDown={this.handleKeyDown}
              onChange={event => {
                this.handleChange("comentario", event.target.value);
              }}
              startAdornment={
                <InputAdornment position="start">
                  <IconButton aria-label="Dejar comentario" tabIndex="-1">
                    <CommentIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </Paper>
      </Grid>
    );
  };

  handlePredios = event => {
    this.handleChange("predio", event.target.value);
  };

  handleMateriales = event => {
    this.handleChange("material", event.target.value);
  }

  handleBolsonesDeUnaEtapa = event => {
    this.setState({ cartoneroNombre: " " });
    this.handleChange("cartonero", "");
    this.handleChange("etapa", event.target.value);
    DataProvider(GET_LIST, "usuarios", {
      filter: {
        etapa: event.target.value,
        _rol: "cartonero"
      },
      pagination: { page: 1, perPage: 500 }
    }).then(response => {
      if (response.data[0]) {
        const cartonerosDeUnaEtapa = response.data.map(cartonero => {
          return {
            _id: cartonero._id,
            nombre: cartonero.nombre,
            bolson: cartonero.bolson
          };
        });
        this.setState({ cartonerosDeUnaEtapa });
      }
    });
  };

  renderInfo = () => {
    return (
      <Grid item xs={12} md={3}>
        <Paper style={styles.paperIcon}>
          <StarIcon style={styles.iconLeft} />
          <FormControl fullWidth>
            <InputLabel htmlFor="predio">Predio</InputLabel>
            <Select
              tabIndex="0"
              autoFocus={true}
              value={this.state.pesaje.predio}
              onChange={this.handlePredios}
              input={<Input name="nombre" id="predios-helper" />}
            >
              {this.state.prediosList &&
                this.state.prediosList.map((value, i) => (
                  <MenuItem key={`predios_${i}}`} value={value._id}>
                    {value.nombre}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Paper>
        <Paper style={styles.paperIcon}>
          <LocalShippingIcon style={styles.iconLeft} />
          <FormControl fullWidth>
            <TextField
              label="Camión"
              value={this.state.pesaje.camion}
              onChange={event => {
                this.handleChange("camion", event.target.value);
              }}
            />
          </FormControl>
        </Paper>
        <Paper style={styles.paperIcon}>
          <PersonPinCircle style={styles.iconLeft} />
          <FormControl fullWidth>
            <InputLabel htmlFor="etapas">Etapas / Rutas</InputLabel>
            <Select
              value={this.state.pesaje.etapa}
              onChange={this.handleBolsonesDeUnaEtapa}
              input={<Input name="nombre" id="etapas-helper" />}
            >
              {this.state.etapasList &&
                this.state.etapasList.map((value, i) => (
                  <MenuItem key={`etapas_${i}}`} value={value.nombre}>
                    {value.nombre}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Paper>
        <Paper style={styles.paperIcon}>
          <TodayIcon style={styles.iconLeft} />
          <FormControl fullWidth>
            <MuiPickersUtilsProvider
              utils={MomentUtils}
              moment={moment}
              locale="es"
            >
              <DatePicker
                name="fecha"
                label="Fecha de recolección"
                value={this.state.pesaje.fecha}
                onChange={date => {
                  this.handleChange("fecha", date);
                }}
              />
            </MuiPickersUtilsProvider>
          </FormControl>
        </Paper>
      </Grid>
    );
  };

  render() {
    return (
      <Dialog
        fullScreen
        open={this.state.open}
        onClose={this.handleClose}
        TransitionComponent={this.transition}
      >
        <AppBar style={styles.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={this.handleClose}
              aria-label="Close"
              tabIndex="-1"
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="title" style={styles.title}>
              Cargar pesaje
            </Typography>
            <Button
              id="botonGuardar"
              color="inherit"
              onClick={this.handleSubmit}
              disabled={
                this.state.pesaje.etapa === "" ||
                this.state.pesaje.bolson === "" ||
                this.state.isSaving
              }
            >
              Guardar
            </Button>
          </Toolbar>
        </AppBar>
        <Grid>
          <Grid container spacing={0}>
            {this.renderInfo()}
            {this.renderPesaje()}
            {this.renderWeightInfo()}
          </Grid>
        </Grid>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pesajes/PesajeCreateComponent_tpl.js